import { Injectable } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';

@Injectable()
export class RouteChangeService {
  public inNavigation: boolean = false;

  constructor(private router: Router) {
    // Track if a route change is happening.
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.inNavigation = true;
      } else if (event instanceof NavigationEnd) {
        this.inNavigation = false;
      }
    });
  }
}
